import { User } from '@ffx/common';

export type TaigaSize = 's' | 'm' | 'l' | 'xl' | 'xs';

export type AppState = {
    isLoggedIn: boolean;
    user: User;
};

export const initialState: AppState = {
    isLoggedIn: false,
    user: {
        email: '',
        uid: '',
        theme: 'light'
    }
};
